import { render, staticRenderFns } from "./SecondGiftsYN.vue?vue&type=template&id=0d99b959"
import script from "./SecondGiftsYN.vue?vue&type=script&lang=js"
export * from "./SecondGiftsYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports